import { render, staticRenderFns } from "./attr-color.vue?vue&type=template&id=8e2a3228&scoped=true"
import script from "./attr-color.vue?vue&type=script&lang=js"
export * from "./attr-color.vue?vue&type=script&lang=js"
import style0 from "./attr-color.vue?vue&type=style&index=0&id=8e2a3228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2a3228",
  null
  
)

export default component.exports